<template>
    <div class="page-content">
        <Skeleton
            height="50px"
            class="mb-5"
        />

        <Skeleton
            height="30px"
            class="mb-2.5"
        />
        <Skeleton
            height="30px"
            class="mb-5"
        />

        <Skeleton
            height="250px"
            class="mb-5"
        />

        <div class="grid grid-cols-1 min-[961px]:grid-cols-2 gap-5">
            <Skeleton
                height="250px"
                class="mb-5"
            />
            <Skeleton
                height="250px"
                class="mb-5"
            />
        </div>
    </div>
</template>

